// 广告管理相关页面组件
import EmptyRouterView from '../components/EmptyRouterView/index.vue'
import AdManagement from '../views/ad/index.vue'
import AdTypeManagement from '../views/ad/type.vue'
import AdMessageManagement from '../views/ad/message.vue'

// 广告管理路由配置
export const adRoutes = {
  path: 'ad',
  name: 'AdManagement',
  component: EmptyRouterView,
  meta: {
    title: '广告管理',
    icon: 'el-icon-s-promotion',
    hidden: false
  },
  children: [
    {
      path: 'list',
      name: 'AdList',
      component: AdManagement,
      meta: {
        title: '广告列表',
        icon: 'el-icon-notebook-2',
        hidden: false
      }
    },
    {
      path: 'type',
      name: 'AdTypeManagement',
      component: AdTypeManagement,
      meta: {
        title: '广告类型',
        icon: 'el-icon-collection-tag',
        hidden: false
      }
    },
    {
      path: 'message',
      name: 'AdMessageManagement',
      component: AdMessageManagement,
      meta: {
        title: '留言中心',
        icon: 'el-icon-chat-dot-round',
        hidden: false
      }
    }
  ]
}
